import { Link } from "react-router-dom";
import { useShop, useSeo } from "@/lib/store";
import { ProductGrid } from "@/components/ProductCard";

export default function Wishlist() {
  useSeo("Wishlist");
  const { wish } = useShop();
  return (
    <div className="max-w-[1500px] mx-auto px-4 sm:px-8 py-12" data-testid="wishlist-page">
      <h1 className="font-display text-5xl sm:text-6xl">WISHLIST</h1>
      {wish.length ? <div className="mt-10"><ProductGrid items={wish} /></div> : (
        <div className="py-24 text-center" data-testid="wishlist-empty"><p className="font-display text-3xl">NOTHING SAVED YET.</p><Link to="/shop" className="btn-neon mt-6">Explore</Link></div>
      )}
    </div>
  );
}
